/* eslint-disable no-unused-vars */

/* eslint-disable class-methods-use-this */

/* eslint-disable prefer-promise-reject-errors */
import axios from "axios";

import {
  API_CAPACITY_URL,
  API_E_INVOICE_URL,
  API_ORDER_MANAGEMENT_URL,
  API_REFUNDS_PAYMENT,
  API_TMS,
  API_TMS_KEY,
  COMMON_HEADER_CONFIG
} from "../config";

class OrderService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchOrders = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/orders`,
        params: {
          per_page: 500,
          page: 1,
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error.response?.data?.error);
        });
    });

  getListOrders = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/orders`,
        params: {
          size: 500,
          page: 1,
          sort: "created_at DESC"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };
      if (data && "state" in data) {
        config.params.state = data.state;
      }

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createOrder = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ORDER_MANAGEMENT_URL}/order`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createOrderAdminPortal = (data) =>
    new Promise((resolve, reject) => {
      // const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ORDER_MANAGEMENT_URL}/create-order`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });

  updateOrderAdminPortal = (data, orderId) =>
    new Promise((resolve, reject) => {
      // const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${orderId}/add-edit-order-items?edit_from=AP`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });

  updateOrder = ({id, ...rest}) =>
    new Promise((resolve, reject) => {
      const {force, ...restData} = rest;
      const config = {
        method: "patch",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: restData,
        params: {
          force: Boolean(force)
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrder = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteOrder = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.code === 1 || response.data.code === "success") {
            resolve(response.data.code);
          } else {
            reject(response.data.code);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderItems = (data) =>
    new Promise((resolve, reject) => {
      // per_page: limit,
      // page: page + 1,
      // orderId: orderId,
      const config = {
        method: "get",
        // url: `${API_ORDER_MANAGEMENT_URL}/order-items`,
        url: `${API_ORDER_MANAGEMENT_URL}/order/${data?.orderId}`,
        // params: {
        //   size: data?.per_page ?? 10,
        //   page: data?.page ?? 1,
        //   trade_order_id: data?.orderId,
        // },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateOrderItems = (data) =>
    new Promise((resolve, reject) => {
      // per_page: limit,
      // page: page + 1,
      // orderId: orderId,
      const config = {
        method: "patch",
        url: `${API_ORDER_MANAGEMENT_URL}/order-item/${data?.id}`,
        data: JSON.stringify(data),
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getLinkInvoice = (orderNumber) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_E_INVOICE_URL}/e-invoice/get-invoice-url`,
        params: {
          order_id: orderNumber,
          action: "viewer"
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.data) {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getRefunds = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_REFUNDS_PAYMENT}/list_refunds`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  transferPayment = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "patch",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  orderHistory = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/order-history-edit/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  printForCustomer = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        responseType: "blob",
        url: `${API_ORDER_MANAGEMENT_URL}/print-order-customer/${id}?print_type=pdf`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  exportOrderInvoiceManual = (orderId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/export-manual-invoice/${orderId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject({message: response.data.message});
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  exportOrderInvoiceReplace = (orderId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/export-replace-invoice/${orderId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject({message: response.data.message});
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  printForPicker = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        responseType: "blob",
        url: `${API_ORDER_MANAGEMENT_URL}/print-order-picker/${id}?print_type=pdf`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  printLabel = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        responseType: "blob",
        url: `${API_ORDER_MANAGEMENT_URL}/print-label/${id}?print_type=pdf`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOrderStatus = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_ORDER_MANAGEMENT_URL}/order/${id}/status`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getWaybillHistory = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TMS}/history/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "api-key": API_TMS_KEY
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getTimeSlotDeliveryOrder = ({stationId}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CAPACITY_URL}/list-timeslot/${stationId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          resolve({
            code: "success",
            data: response.data // because response from backend is not follow criteria of standard
          });
        })
        .catch((error) => {
          resolve({
            code: "error",
            data: error.response.data
          });
        });
    });

  getDateTimeDeliveryOrder = ({enabled, stationId, wardId}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_CAPACITY_URL}/received-time`,
        params: {
          enabled: enabled ?? true,
          station_id: stationId,
          ward_id: wardId
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        }
      };

      axios(config)
        .then((response) => {
          resolve({
            code: "success",
            data: response.data.data
          });
        })
        .catch((error) => {
          resolve({
            code: "error",
            data: error.response.data
          });
        });
    });

  /**
   *
   * @param {string} station_id id of station
   * @param {string} channel channel
   * @param {objects[]} order_item [{id: number, manufacturing_barcode: string, ordered_quantity: number, ordered_unit_price: number, special_instruction: string},...]
   */
  importOrders = (station_id, channel = "", order_item) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_ORDER_MANAGEMENT_URL}/validate-import-order-item`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: {
          station_id,
          channel,
          order_item
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const orderService = new OrderService();

export default orderService;
